import { provideRouter } from '@angular/router';
import { ProjectsRoutes } from './project.routing';
import { ProjectsReducer, ProjectsState } from './state/reducers/projects.reducer';
import { MetaReducer, Action, provideState } from '@ngrx/store';
import { projectsStateKey } from './state';
import { provideEffects } from '@ngrx/effects';
import { ProjectsEffects } from './state/effects/projects.effects';
import { createLocalStorageSyncReducer } from '../../shared/utils/local-storage-sync';

const localStorageSyncReducer = createLocalStorageSyncReducer<ProjectsState>([
  'projectsList',
  'selectedProject',
  'projectDetails',
  'projectUsersList',
  'projectPermissionGroups',
]);

const metaReducers: Array<MetaReducer<ProjectsState, Action>> = [localStorageSyncReducer];

export const projectsConfig = [
  provideRouter(ProjectsRoutes),
  provideState(projectsStateKey, ProjectsReducer, { metaReducers }),
  provideEffects([ProjectsEffects]),
  // Note: Services and facades with providedIn: 'root' don't need to be listed here
];
